import { Button, Grid, IconButton, Typography } from "@mui/material";
import React, { useState } from "react";
import { DataGrid } from "@mui/x-data-grid";
import { WSIcons } from "../../commonFunctions/iIcons";
import WSDataGrid, { IColumns } from "../../Components/DataGrid/WSDataGrid";
import { SearchDrawer } from "./SearchDrawer";
import Footer from "../OrderTypeTransactions/Footer";
import { useNavigate } from "react-router-dom";

export const ItemSearch: React.FC<any> = React.memo((props) => {
    const [cartOpen, setCartOpen] = useState(false);
    const navigate = useNavigate()
    const handleCartClick = () => {
        setCartOpen(true);
    };
    
    const handleCartClose = () => {
        setCartOpen(false);
    };

    const columns: IColumns[] = [
        {
            header: "itemcode",
            fieldName: "workLocationName",
            tooltip: true,
        },
        {
            header: "itemname",
            fieldName: "address",
            tooltip: true,
        },
        {
            header: "menu subgroup",
            fieldName: "address",
            tooltip: true,
        },
        {
            header: "rate",
            fieldName: "address",
            tooltip: true,
        },
        {
            header: "Freeze",
            fieldName: "address",
            tooltip: true,
        },
    ];

    const handleClick = (path:string) =>{
        navigate(path)
       }
     

    return (
        <Grid container direction="column"  sx={{ minHeight: '100vh' }}>
            {/* Header Section */}
            <Grid item>
                <Grid sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', padding: '16px' }}>
                    {/* Title on the left */}
                    <Typography variant="h6" sx={{ fontWeight: 'bold', color: "green" }}>
                        Search Item
                    </Typography>
                    <Grid sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                        <IconButton>
                            <WSIcons.SyncIcon />
                        </IconButton>
                        <IconButton onClick={handleCartClick}>
                            <WSIcons.SearchIcon />
                        </IconButton>
                        <SearchDrawer open={cartOpen} onClose={handleCartClose} />
                        <IconButton>
                            <WSIcons.CloseIcon sx={{ backgroundColor: 'red', color: 'white' }} onClick={()=>handleClick('/takeaway')}/>
                        </IconButton>
                    </Grid>
                </Grid>
            </Grid>

            {/* DataGrid Section */}
            <Grid item sx={{ flex: 1 }}>
                <WSDataGrid
                    id="itemGrid"
                    title=""
                    columns={columns}
                />
            </Grid>

            {/* Footer Section */}
            <Grid item
      sx={{
        backgroundColor: "#333", 
        padding: "1rem",
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center",
      }}
    >
      <Grid container spacing={2} alignItems="center" gap={3}>
        <Grid item>
          <WSIcons.GTranslateIcon sx={{ color: "white" }} />
        </Grid>
        
      </Grid>

        <Button
          variant="contained"
          sx={{
            backgroundColor: "green",
            "&:hover": {
              backgroundColor: "#388e3c",
            },
          }}
        >
          Finish
        </Button>
      </Grid>
        </Grid>
    );
});
